// Defined in its own import.meta-free module so session logic stays unit-testable;
// re-exported here because this is where the app imports it from.
export { STORAGE_KEYS } from './storage-keys';

export const DASH = '-';
export const NA = 'N/A';
export const ROUTE_ID = ':id';

export const DATE_TIME_TRANSFER_FORMAT = 'YYYY-MM-DD HH:mm';
export const DATE_TIME_VISUAL = 'YYYY-MM-DD h:mm a';
export const DATE_TIME_VISUAL_FULL_WITH_SECONDS = 'YYYY-MM-DD HH:mm:ss a';
export const DATE_VISUAL = 'YYYY-MM-DD';

export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];

// API URL from environment or default
export const API_URL = import.meta.env.VITE_API_URL || '/api';

export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;
